"use client";

import { useTheme } from "@/providers/ThemeProvider";
import { Moon, Sun } from "lucide-react";
import { useSyncExternalStore } from "react";

function subscribe() {
  return () => {};
}

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isMounted = useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );

  if (!isMounted) {
    return (
      <button className="mc-btn inline-flex items-center justify-center p-2" aria-label="Toggle theme" disabled>
        <Sun className="h-5 w-5 text-accent" />
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      className="mc-btn inline-flex items-center justify-center p-2"
      aria-label="Toggle theme"
    >
      {theme === "light" ? <Moon className="h-5 w-5 text-secondary" /> : <Sun className="h-5 w-5 text-accent" />}
    </button>
  );
}
